import React, { useState } from "react";
import { Image, Tooltip } from 'antd';
import './ImageViewer.scss';

export default function ImageViewer(props) {
    const {images} = props;
    const [visible, setVisible] = useState(false);

    return (
        <div >
            <div className="images-container">
                {images?.map((src, index) => {
                    if (index < 3)
                        return (
                            <span style={{ marginRight: "4px" }}>
                                <Image width={100} height={100} src={src}
                                    preview={{
                                        visible: false,
                                    }}
                                    onClick={() => setVisible(true)}
                                />
                            </span>
                        )
                })}
                {images?.length > 3 &&
                    <Tooltip title="Click to view all">
                        <span className="more-text" onClick={() => setVisible(true)}>{`+${images?.length - 3} more`}</span>
                    </Tooltip>
                }
            </div>
            <div className="hidden-container">
                <Image.PreviewGroup
                    preview={{
                        visible,
                        onVisibleChange: (vis) => setVisible(vis),
                    }}>
                    {images?.map((src, index) => {
                        return (
                            <Image width={100} height={100} src={src} />
                        )
                    })}
                </Image.PreviewGroup>
            </div>
        </div>
    );
}


